<div class="{{small ? 'small' : '' }} logo-bigger">
  <img src="assets/images/logo-bigger-white.png" *ngIf="!showAlt" alt="Bigger Picture"/>
  <img src="assets/images/logo-bigger-black.png" *ngIf="showAlt" alt="Bigger Picture"/>
</div>
